import axios from 'lib/axios';

const getProfile = async () => {
  const { data } = await axios.get('/admin/me');
  return data;
};

const getCustomerProfile = async () => {
  const { data } = await axios.get(`/customer/me`);
  return data;
};

export { getProfile, getCustomerProfile };
